export default new class Utils {
  constructor() {
    this.textForCutSelector = '_js-cutted';
    this.handler();

    this.textLength = 75;
  }

  handler() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    const textCollection = document.querySelectorAll(`.${this.textForCutSelector}`);

    if (!textCollection.length) return;

    [...textCollection].forEach(el => this.cutText(el));
  }

  cutText(el) {
    const text = el.textContent;
    const textLength = el.getAttribute('data-cut-length');

    if (text.length < textLength) return;

    const newText = text.slice(0, textLength).concat('...');

    el.setAttribute('title', text);

    el.textContent = newText;
  }
}();
